<template lang="pug">
  .height-100
    h3
      .title Boletas transferidas
        span.litle(v-if="boletas.length > 0")  ({{ boletas.length }} para generar)

    .center.margin-top-10
      .button.is-primary(
        @click="exportarExcel"
        :class="{ 'is-loading': isExporting }"
      )
        span Exportar a Excel

      .button.is-primary(
        @click="empezarAGenerar"
        :class="{ 'is-loading': isGenerating }"
      )
        span Generar

    transition(name="fade")
      p.margin-top-10(v-if="isGenerating")
        vue-circle(
          :progress="0.0"
          :size="100"
          insert-mode="append"
          :fill="fillCircle"
          ref="progressCircle"
        )
          p {{ boletasGeneradas }} / {{ cantidadBoletas }}

    p.margin-bottom-10
    spinner(
      v-if="isFetching"
      size="60"
      line-fg-color="#3a4dc7"
      :line-size="7"
    )
    div(v-else)
      .article.message.is-info(v-if="boletas.length === 0")
        section.message-body
          span No hay boletas para transferir
      .contenedor-transferidas
        .box(
          v-for="o in boletas"
          v-if="boletas.length > 0"
        )
          boleta-item-transferidos(
            :boleta="o"
          )
</template>

<script>
import BoletaItemTransferidos from './Component_Boletas_Item_Transferidos'
import { apiGet, apiPost, apiGetExcel, notify } from '../util/general'
import VueCircle from 'vue2-circle-progress'
import Spinner from 'vue-simple-spinner'
export default {
  name: 'boletas-transferidas',
  components: {
    BoletaItemTransferidos,
    VueCircle,
    Spinner
  },
  data () {
    return {
      boletas: [],
      isFetching: true,
      isGenerating: false,
      isExporting: false,
      boletasGeneradas: 0,
      cantidadBoletas: 0,
      fillCircle: { color: '#3a4dc7' }
    }
  },
  watch : {
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isFetching = true
      var obj = {}
      apiGet(vm, '/boleta/transferidas', obj, function (data) {
        vm.boletas = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isFetching = false
      })
    },
    empezarAGenerar () {
      var vm = this
      vm.boletasGeneradas = 0
      vm.cantidadBoletas = vm.boletas.length
      vm.isGenerating = true
      vm.generar()
    },
    generar () {
      var vm = this
      vm.isGenerating = true

      var obj = {
      }

      apiPost(vm, '/boleta/transferidas/generar', obj, function (data) {
        if (data.noMore) {
          notify(vm, 'success', 'Éxito', 'Todas las boletas generadas correctamente')
          vm.fetch()
          vm.isGenerating = false
        } else {
          // notify(vm, 'success', 'Éxito', 'Generado correctamente boleta de ' + data.nombre)
          vm.boletasGeneradas++
          var progresoPorcentaje = vm.boletasGeneradas / vm.cantidadBoletas * 100.0
          vm.$refs.progressCircle.updateProgress(progresoPorcentaje);
          vm.generar()
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.isGenerating = false
      })
    },
    exportarExcel () {
      var vm = this
      vm.isExporting = true
      var obj = {
        unico: 'transferido'
      }
      apiGetExcel(vm, '/boleta/auxiliar/excel/descarga', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = 'transferidos_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        console.error('Error:' + error.message)
      }, function () {
        vm.isExporting = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .height-100
    height 100%
    min-height 100%
    position relative

  .contenedor-transferidas
    display flex
    flex-wrap wrap
    justify-content: space-around;

  .margin-bottom-10
    margin-bottom 10px

  .box
    margin 5px

  .title
    .litle
      font-size 16px

  .center
    display flex
    justify-content center
    .button
      margin-left 10px
</style>



// WEBPACK FOOTER //
// View_Boletas_Transferidas.vue?1200e6ea